"use strict";
/** state: Final **/
/** family: Tabs **/
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var classNames = require("classnames");
var React = require("react");
var metrics_1 = require("../../metrics");
var Nav_1 = require("../Nav");
var NavItem_1 = require("../NavItem");
var Tab_1 = require("../Tab");
var CLASS_NAME = 'i-tabs';
/**
 * Tabs are used to display modular pieces of related data that do not need to be compared or accessed simultaneously.
 */
var Tabs = /** @class */ (function (_super) {
    __extends(Tabs, _super);
    function Tabs(props) {
        var _this = _super.call(this, props) || this;
        _this.tabRefs = [];
        _this.handleSelect = function (index, onSelect, callback) {
            if (_this.props.shouldSwitchTabs &&
                !_this.props.shouldSwitchTabs(index, _this.state.activeTabIndex)) {
                return;
            }
            _this.setState({
                activeTabIndex: index,
            }, callback);
            if (_this.props.metricOptions) {
                var metricOptions = __assign({}, _this.props.metricOptions, { metricKey: _this.props.metricOptions.metricKey + "." + index });
                return metrics_1.trackMetric(metricOptions, onSelect)(index);
            }
            else if (onSelect) {
                onSelect(index);
            }
        };
        _this.isActive = function (index) { return _this.state.activeTabIndex === index; };
        _this.state = {
            activeTabIndex: _this.props.activeTabIndex,
        };
        return _this;
    }
    Tabs.prototype.UNSAFE_componentWillReceiveProps = function (nextProps) {
        if (nextProps.activeTabIndex !== this.props.activeTabIndex) {
            this.setState({ activeTabIndex: nextProps.activeTabIndex });
        }
    };
    Tabs.prototype.render = function () {
        var _this = this;
        var _a = this.props, activeTabIndex = _a.activeTabIndex, children = _a.children, className = _a.className, id = _a.id, lazy = _a.lazy, metricOptions = _a.metricOptions, mode = _a.mode, onSelect = _a.onSelect, shouldSwitchTabs = _a.shouldSwitchTabs, restProps = __rest(_a, ["activeTabIndex", "children", "className", "id", "lazy", "metricOptions", "mode", "onSelect", "shouldSwitchTabs"]);
        var tabs = !Array.isArray(children)
            ? Array(children)
            : children;
        for (var i = 0; i < tabs.length; i++) {
            this.tabRefs[i] = React.createRef();
        }
        return (React.createElement("div", __assign({ className: classNames(CLASS_NAME, className), id: id }, restProps),
            React.createElement(Nav_1.Nav, { navStyle: mode, role: Nav_1.NavRole.TabList }, tabs
                .filter(function (tab) { return tab; })
                .map(function (tab, index) { return (React.createElement(NavItem_1.NavItem, { active: _this.isActive(index), disabled: tab.props.disabled, id: id + "_tab-" + index, isTab: true, key: index, href: "#" + id + "_pane-" + index, label: tab.props.title, onClick: function (e) {
                    // prevent scrolling behaviour, we still want it to focus
                    // on the target element however, so we handle that below.
                    e.preventDefault();
                    // Must always be called otherwise Lazy tabs breaks
                    _this.handleSelect(index, onSelect, function () {
                        var ref = _this.tabRefs[index];
                        if (!ref || !ref.current) {
                            console.warn('Tabs.tsx: Cannot find tab panel by reference.');
                            return;
                        }
                        // Wait 1 frame for "display: block" to take effect
                        // so that we can actually focus the element for screen
                        // readers.
                        //
                        // Focusing the element without the "requestAnimationFrame" callback
                        // will not break tests but it will stop a real screen reader (NVDA) from
                        // working. (ie. It simply doesn't read out the content of the tab you
                        // just selected.)
                        //
                        var el = ref.current;
                        window.requestAnimationFrame(function () {
                            el.focus();
                        });
                    });
                } })); })),
            React.createElement("div", { className: "tab-content" }, tabs
                .filter(function (tab) { return tab; })
                .map(function (tab, index) {
                return (!lazy || _this.isActive(index)) && (React.createElement(Tab_1.Tab, __assign({ ref: _this.tabRefs[index], active: _this.isActive(index), key: index, titleAriaLabelledBy: id + "_tab-" + index, titleId: id + "_pane-" + index }, tab.props)));
            }))));
    };
    Tabs.Mode = Nav_1.NavStyle;
    Tabs.defaultProps = {
        activeTabIndex: 0,
        mode: Nav_1.NavStyle.Tabs,
    };
    return Tabs;
}(React.Component));
exports.Tabs = Tabs;
//# sourceMappingURL=Tabs.js.map